'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AvatarSize = {
  EXTRA_SMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl'
};
exports.default = AvatarSize;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/constants/AvatarSize.js
// module id = 493
// module chunks = 2 3